import { Controller, set, useForm } from "react-hook-form";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Label } from "../../../components/Label/Label";
import PageTitle from "../../../components/PageTitle/PageTitle";
import HelperService from "../../../utility/HelperService";
import { useEffect, useState } from "react";
import routePaths from "../../../Navigation/routePaths";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import WebService from "../../../utility/WebService";
import { toast } from "react-toastify";
import Select from "react-select";
import PlotDatePicker from "../../../components/PlotDatePicker/PlotDatePicker";
import UploadFile from "../../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../../assets/images/doc-icon.svg";
import AddBankAccount from "./AddBankAccount";
import { useSelector } from "react-redux";
import { permissionsInterface } from "../../onBoarding/onBoardingTypes";
import API from "../../../utility/API-endPoints";



const CreateReceipt = () => {
  const navigate = useNavigate();
  const { handleSubmit, formState: { errors, isValid }, control, watch, register, reset, setValue, } = useForm<any>({});
  const watchAllFields = watch();
  const { id }: any = useParams();
  const [expenseDetail, setExpenseDetail] = useState<any>({});
  const [projectList, setProjectList] = useState<any[]>([]);
  const [expenseTypeList, setExpenseTypeList] = useState<any[]>([]);
  const [subExpenseTypeList, setSubExpenseTypeList] = useState<any[]>([]);
  const [openAddBank, setOpenAddBank] = useState<boolean>(false);
  const [paymentModeOptions, setPaymentModeOptions] = useState<any[]>([]);
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const isEdit = window.location.pathname === "/update-expense/" + id;
  const { state } = useLocation();
  const isShowHiddenFields = state?.type ?? false;
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [isLoadingVendor, setIsLoadingVendor] = useState<boolean>(false);
  const [stockList, setStockList] = useState<any[]>([]);
  const [isLoadingStock, setIsLoadingStock] = useState<boolean>(false);
  const [agentList, setAgentList] = useState<any[]>([]);
  const [isLoadingAgent, setIsLoadingAgent] = useState<boolean>(false);
  const [bookingList, setBookingList] = useState<any[]>([]);
  const [isLoadingBooking, setIsLoadingBooking] = useState<boolean>(false);
  const [loanList, setLoanList] = useState<any[]>([]);
  const [isLoadingLoan, setIsLoadingLoan] = useState<boolean>(false);



  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "EXPENSES"));
      !vendorList.length && getVendorList();
      !stockList.length && getStockList();
    }
  }, [token])

  useEffect(() => {
    if (permissions && permissions.can_read) {
      if (window.location.pathname === "/update-expense/" + id && permissions && permissions.can_update) {
        isShowHiddenFields == "REAL" ? setShowHiddenFields(true) : setShowHiddenFields(false);
        getDetail(isShowHiddenFields == "REAL" ? true : false);
      } else {
        reset();
      }
      getProjectList();
      getExpenseTypeList();
      getPaymentModeOptions();
      getAgentList();
      getLoanList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  const getProjectList = () => {
    WebService.getAPI({ action: "get/project/list" })
      .then((res: any) => {
        const defaultOption = [{ value: null, label: "Admin" }];
        if (res.list && res.list.length > 0) {
          res.list.forEach((item: any) => {
            defaultOption.push({
              ...item,
              ...{ value: item.id, label: item.project_name },
            });
          })
        }
        setProjectList(defaultOption);
      })
      .catch((e: any) => { });
  };

  const getExpenseTypeList = () => {
    WebService.getAPI({ action: `get/expense_type/list` })
      .then((res: any) => {
        if (res.list && res.list.length > 0) {
          setExpenseTypeList(
            res.list.map((item: any) => {
              return {
                ...item,
                ...{ value: item.id, label: item.name },
              };
            })
          );
        }
      })
      .catch((e: any) => { });
  };

  const getSubExpenseTypeList = (uuid: string) => {
    WebService.getAPI({ action: `get/sub_expense_type/list/${uuid}` })
      .then((res: any) => {
        setSubExpenseTypeList(
          res.list.map((item: any) => {
            return {
              ...item,
              ...{ value: item.id, label: item.name },
            };
          })
        );
      })
      .catch((e: any) => { });
  };

  const getDetail = (fieldFlag: boolean) => {
    WebService.getAPI({ action: `expense/detail/${id}`, is_session: fieldFlag })
      .then((res: any) => {
        if (res.result) {
          setExpenseDetail(res.result);
          reset(res.result);
          getExpenseTypeList();
          getSubExpenseTypeList(res.result.expense_type?.uuid);
          setValue("photo", res.result.photo);
          setValue("file_size", res.result.file_size);
        }
      })
      .catch((e: any) => { });
  };

  const onUploadFile = (data: any, name: string, size: string) => {
    const blob = URL.createObjectURL(data);
    var isImageExte = /(\.(jpg|jpeg|png))$/i;
    var isVideo = /(\.(mp4))$/i;
    var isPdf = /(\.(pdf))$/i;
    let type = "";

    if (isImageExte.test(name)) {
      type = "IMAGE";
    } else if (isVideo.test(name)) {
      type = "VIDEO";
    } else if (isPdf.test(name)) {
      type = "PDF";
    }
    onSaveFile(data);
    setValue("file_size", size);
  };

  const onSaveFile = async (data: any) => {
    WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data, body: { type: "EXPENSES" }, id: "expense_create_update_btn" })
      .then(async (res: any) => {
        toast.success("File uploaded successfully");
        setValue("photo", res.file_name);
      })
      .catch(async (error: any) => { });
  };

  const onSubmit = (data: any) => {
    if (window.location.pathname === "/update-expense/" + id) {
      WebService.putAPI({
        action: "expense/update",
        body: data,
        id: "expense_create_update_btn",
        is_session: showHiddenFields
      })
        .then((res: any) => {
          navigate(routePaths.EXPENSE.path);
        })
        .catch((e) => { });
    } else {
      WebService.postAPI({
        action: "expense/create",
        body: data,
        id: "expense_create_update_btn",
        is_session: showHiddenFields
      })
        .then((res: any) => {
          navigate(routePaths.EXPENSE.path);
        })
        .catch((e) => { });
    }
  };

  const onDeleteImage = () => {
    setValue("photo", null);
    setValue("file_size", null);
  };

  const getPaymentModeOptions = () => {
    WebService.getAPI({ action: `get/payment_mode/list` })
      .then((res: any) => {
        setPaymentModeOptions(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.name } }; }));
      })
      .catch((e: any) => { });
  };

  const handleKeyDown = (e: any) => {
    const key = e.key ? e.key.toLowerCase() : "";
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key ? e.key.toLowerCase() : "";
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
      if (isEdit) {
        if (isShowHiddenFields === "REAL") {
          setShowHiddenFields(true);
        }
      } else {
        setShowHiddenFields(true);
      }
    }
    setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
  };

  const getVendorList = () => {
    setIsLoadingVendor(true);
    WebService.getAPI({ action: "supplier/list" })
      .then((res: any) => {
        setVendorList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.firm_name } } }));
        setIsLoadingVendor(false);
      }).catch((e: any) => { setIsLoadingVendor(false); })
  };

  const getStockList = () => {
    setIsLoadingStock(true);
    WebService.getAPI({ action: "stock/list" })
      .then((res: any) => {
        setStockList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.name } } }));
        setIsLoadingStock(false);
      }).catch((e: any) => { setIsLoadingStock(false); })
  };

  const getSignedUrl = (fileName: string) => {
    WebService.postAPI({ action: "get/signed-url", body: { key: `expenses/${fileName}` } })
      .then((res: any) => {
        if (res && res.signed_url) {
          window.open(res.signed_url, "_blank");
        } else {
          toast.error("Failed to get signed URL");
        }
      })
      .catch((error: any) => { toast.error("Failed to get signed URL"); });
  };

  const getAgentList = () => {
    setIsLoadingAgent(true);
    WebService.getAPI({ action: API.ALL_AGENT_LIST })
      .then((response: any) => {
        setAgentList(response.list.map((agent: any) => ({ value: agent.id, label: agent.agent_name })));
        setIsLoadingAgent(false);
      }).catch(error => {
        toast.error("Failed to fetch agent list");
        setAgentList([]);
        setIsLoadingAgent(false);
      });
  };

  const getBookingList = (agent_id: number) => {
    setIsLoadingBooking(true);
    WebService.getAPI({ action: `booking-list/by-agent/${agent_id}` })
      .then((response: any) => {
        setBookingList(response.list.map((booking: any) => ({ value: booking.id, label: `${booking.book_id} ${booking.customer_name} ${booking.booked_units && booking.booked_units.length > 0 ? booking.booked_units.map((unit: any) => unit.unit_name).join(", ") : ""}` })));
        setIsLoadingBooking(false);
      }).catch(error => {
        toast.error("Failed to fetch booking list");
        setBookingList([]);
        setIsLoadingBooking(false);
      });
  };

  const getLoanList = () => {
    setIsLoadingLoan(true);
    WebService.getAPI({ action: `banking-loan/list` })
      .then((response: any) => {
        setLoanList(response.list.map((loan: any) => ({ value: loan.id, label: loan.title })));
        setIsLoadingLoan(false);
      }).catch(error => {
        toast.error("Failed to fetch loan list");
        setLoanList([]);
        setIsLoadingLoan(false);
      });
  };


  return (
    <div className="app-page page-dashboard">
      <AddBankAccount isShow={openAddBank} isClose={(e: boolean) => { setOpenAddBank(false); e && getPaymentModeOptions() }} data={null} />
      <div className="d-flex justify-content-between align-items-center ">
        <PageTitle title={window.location.pathname === "/update-expense/" + id ? "Edit Expense" : "Add Expense"} backArrow={true} active={showHiddenFields} />
      </div>
      {permissions && (permissions.can_update || permissions.can_write) && <Card style={{ height: '100%' }}>
        <Card.Body>
          <form className=" form-style" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={6}>
                <Controller
                  control={control}
                  name="project_id"
                  rules={{ required: false }}
                  render={({ field: { onChange } }) => (
                    <Form.Group className="mb-3">
                      <Form.Label>Project Name</Form.Label>
                      <span className="text-danger">*</span>
                      <Select options={projectList} onChange={(e) => { onChange(e.value); }} value={projectList.find((_: any) => _.id == watchAllFields.project_id)} />
                      {errors.project_id && (<div className="login-error mb-3"> <Label title={watchAllFields.project_id ?? "Please select project"} modeError={true} /> </div>)}
                    </Form.Group>
                  )}
                />

                <Row>
                  <Controller
                    control={control}
                    name="payment_mode"
                    rules={{
                      required: true,
                    }}
                    render={({ field: { onChange } }) => (
                      <Form.Group className="mb-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <Form.Label>Payment Mode</Form.Label>
                            <span className="text-danger">*</span>
                          </div>
                          <Link to={"#"} onClick={() => { setOpenAddBank(true) }} className="font-14">Add Account</Link>
                        </div>
                        <Select
                          options={paymentModeOptions}
                          onChange={(e: any) => {
                            onChange(e.value);
                          }}
                          value={paymentModeOptions.find(
                            (_: any) => _.value == watchAllFields.payment_mode
                          )}
                        />
                        {errors.payment_mode && (
                          <div className="login-error mb-3">
                            <Label
                              title={"Please select payment mode"}
                              modeError={true}
                            />
                          </div>
                        )}
                      </Form.Group>
                    )}
                  />
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <span className="text-danger">*</span>
                    <div className="input-group mb-1">
                      <input
                        type="text"
                        className="form-control ps-3 p-2"
                        placeholder="Amount"
                        {...register("amount", { required: true })} //, min: 1
                        onKeyPress={HelperService.allowOnlyNumericValue}
                      />
                    </div>
                    {errors.amount && (
                      <div className="login-error mb-3">
                        <Label title={"Please enter amount"} modeError={true} />
                      </div>
                    )}
                  </Form.Group>

                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="vendor_id"
                      rules={{ required: false }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Supplier</Form.Label>
                          <div className="input-group mb-1">
                            <Select
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={vendorList}
                              onChange={(e: any) => { onChange(e.value); }}
                              value={vendorList?.find((option: any) => option.value === watchAllFields.vendor_id)}
                              placeholder="Select Supplier"
                            />
                          </div>
                        </Form.Group>
                      )}
                    />
                  </Col>

                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="stock_id"
                      rules={{ required: watchAllFields.vendor_id ? true : false }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Stock</Form.Label>
                          {watchAllFields.vendor_id && <span className="text-danger">*</span>}
                          <div className="input-group mb-1">
                            <Select
                              isLoading={isLoadingStock}
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={stockList}
                              onChange={(e: any) => { onChange(e.value); setValue('unit_id', e.unit_id); setValue('unit', e.unit.name) }}
                              value={stockList?.find((option: any) => option.value === watchAllFields.stock_id)}
                              placeholder="Select Stock"
                            />
                          </div>
                          {errors.stock_id && (<div className="login-error mb-3"> <Label title={"Please select stock"} modeError={true} /> </div>)}
                        </Form.Group>
                      )}
                    />
                  </Col>

                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="agent_id"
                      rules={{ required: false }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Agent</Form.Label>
                          <div className="input-group mb-1">
                            <Select
                              isLoading={isLoadingAgent}
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={agentList}
                              onChange={(e: any) => { onChange(e.value); getBookingList(e.value); }}
                              value={agentList?.find((option: any) => option.value === watchAllFields.agent_id)}
                              placeholder="Select Agent"
                            />
                          </div>
                        </Form.Group>
                      )}
                    />
                  </Col>

                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="booking_id"
                      rules={{ required: watchAllFields.agent_id ? true : false }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Booking</Form.Label>
                          {watchAllFields.agent_id && <span className="text-danger">*</span>}
                          <div className="input-group mb-1">
                            <Select
                              isLoading={isLoadingBooking}
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={bookingList}
                              onChange={(e: any) => { onChange(e.value); }}
                              value={bookingList?.find((option: any) => option.value === watchAllFields.booking_id)}
                              placeholder="Select Booking"
                            />
                          </div>
                          {errors.booking_id && (<div className="login-error mb-3"> <Label title={"Please select booking"} modeError={true} /> </div>)}
                        </Form.Group>
                      )}
                    />
                  </Col>

                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="loan_id"
                      rules={{ required: false }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Loan</Form.Label>
                          <div className="input-group mb-1">
                            <Select
                              isLoading={isLoadingLoan}
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={loanList}
                              onChange={(e: any) => { onChange(e.value); }}
                              value={loanList?.find((option: any) => option.value === watchAllFields.loan_id)}
                              placeholder="Select Loan"
                            />
                          </div>
                        </Form.Group>
                      )}
                    />
                  </Col>

                  <Col lg={12}>
                    {!watchAllFields.photo && <UploadFile
                      key={new Date().getTime()}
                      onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                      acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                      message="Upload or Drag and Drop image"
                      acceptedSize={5}
                    />}

                    {(watchAllFields.photo) &&
                      <Card
                        className={`border p-2 d-inline-block px-3 mb-3 me-2 h-auto`}
                      >
                        <div className="d-flex gap-3 align-items-center">
                          <div className="me-1">
                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                          </div>
                          <div> <img src={DocIcon} width={40} height={40} alt="" /> </div>
                          <div>
                            <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(watchAllFields.photo)}>
                              {watchAllFields.photo}
                            </p>
                          </div>
                        </div>
                      </Card>}
                  </Col>
                </Row>
              </Col>

              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <Controller
                      control={control} name="expense_type_id" rules={{ required: true }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div><Form.Label>Expense Type</Form.Label><span className="text-danger">*</span></div>
                            <Link to={routePaths.ADD_EXPENSE_TYPE.path} className="font-14">Add Expense Type</Link>
                          </div>
                          <Select options={expenseTypeList} onChange={(e) => { onChange(e.value); getSubExpenseTypeList(e.uuid); }} value={expenseTypeList.find((_: any) => _.id == watchAllFields.expense_type_id)} />
                          {errors.expense_type_id && (<div className="login-error mb-3"><Label title={"Please select expense type"} modeError={true} /></div>)}
                        </Form.Group>
                      )}
                    />
                  </Col>
                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="sub_expense_type_id"
                      rules={{ required: true }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <div> <Form.Label>Sub Expense Type</Form.Label> <span className="text-danger">*</span></div>
                          <Select
                            options={subExpenseTypeList}
                            onChange={(e) => { onChange(e.value); }}
                            value={subExpenseTypeList.find((_: any) => _.id == watchAllFields.sub_expense_type_id)}
                          />
                          {errors.sub_expense_type_id && (<div className="login-error mb-3"> <Label title={"Please select sub expense type"} modeError={true} /></div>)}
                        </Form.Group>
                      )}
                    />
                  </Col>
                </Row>

                <Controller
                  control={control}
                  name="payment_date"
                  rules={{
                    required: true,
                  }}
                  render={({ field: { onChange } }) => (
                    <Form.Group className="mb-3">
                      <Form.Label>Payment Date</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="w-100">
                        <PlotDatePicker selected={watchAllFields.payment_date} maxData={new Date()} onChange={(date: any) => { onChange(date); }} placeholderText="Payment Date" />
                      </div>
                      {errors.payment_date && (<div className="login-error mb-3"><Label title={"Please enter payment date"} modeError={true} /></div>)}
                    </Form.Group>
                  )}
                />
                <Form.Group className="mb-3">
                  <Form.Label>Cheque/Voucher/RTGS Number</Form.Label>  <span className="text-danger">*</span>
                  <div className="input-group mb-1">
                    <input type="text" className="form-control ps-3 p-2" placeholder="Cheque/Voucher/RTGS Number" {...register("utr_number", { required: true })} />
                  </div>
                  {errors.utr_number && (<div className="login-error mb-3"> <Label title={"Please enter utr number"} modeError={true} /> </div>)}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Comment</Form.Label>
                  {/* <span className="text-danger">*</span> */}
                  <div className="input-group mb-1 mt-1">
                    <textarea rows={4} className="form-control ps-3 p-2" placeholder="Comment" value={watch().comment} {...register("comment", { required: false })} />
                  </div>
                </Form.Group>
              </Col>

              <Col lg={3}></Col>
              <Col lg={6} className="text-center">
                <Button
                  className="btn-brand-1 me-3 w-50 mt-2"
                  disabled={!isValid}
                  type="submit"
                  id="expense_create_update_btn"
                >
                  {window.location.pathname === "/update-expense/" + id
                    ? "Update"
                    : "Save"}
                </Button>
              </Col>
            </Row>
          </form>
        </Card.Body>
      </Card>}
    </div>
  );
};

export default CreateReceipt;
